/** Playful slab UI — teal primary, indigo secondary (see `.cursor/rules/playful-slab-ui.mdc`). */
export const slab = {
  teal: "#14B8A6",
  tealLip: "#0F766E",
  indigo: "#6366F1",
} as const;

export const faqLabelClass =
  "flex flex-col gap-2 text-sm font-extrabold uppercase tracking-wide text-[#777777]";
